import { t } from '@ping/helpers';
import { userIdSelector, useUserInformationStore } from '@ping/stores/userInformation.store';
import { Form, Question, SelectableOptionsList, TextField } from '@ping/uikit';
import { useContext } from 'react';

import { FormBWizardContext } from '../form-b-wizard.context';

type IFormBWizardContentProps = ICustomizable;

export const FormBWizardContent = (props: IFormBWizardContentProps) => {
  const ctx = useContext(FormBWizardContext);
  const userId = useUserInformationStore(userIdSelector);

  return (
    <Form.Content className={props.className}>
      <input type='hidden' name='userId' value={userId} />

      <Question.Root>
        <Question.Title>{ctx.wizard.question}</Question.Title>
        <Question.Subtitle>{t('Financial regulations require us to ask this question.')}</Question.Subtitle>
        <Question.Options>
          <SelectableOptionsList
            options={ctx.wizard.options}
            defaultValue={ctx.selectedValue}
            name={ctx.wizard.name}
            onChange={ctx.onSelect}
          />
          {ctx.isOtherIndustry && (
            <TextField
              placeholder={t('Industry')}
              name='otherIndustry'
              defaultValue={ctx.otherIndustry}
              onChange={ctx.onOtherIndustryChange}
            />
          )}
        </Question.Options>
      </Question.Root>
    </Form.Content>
  );
};
